module.exports = __webpack_public_path__ + "static/media/bgContactMD.389621da.jpg";